module.exports = __webpack_public_path__ + "img/new-guide-00-1.d8f45df4.png";